import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api"; // Import your axios instance

// Create an async thunk for the API call
export const fetchUsers = createAsyncThunk(
  "assessments/fetchUsers",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await api.get("/assessment/get_user/", {
        params: queryParams, // Pass queryParams as the params for the API request
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getUserDetail = createAsyncThunk(
  "assessments/getUserDetail",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/user/user/me/"); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Define the initial state of the slice
const initialState = {
  users: [], //Added later on
  data: {},
  singleRecord: {},
  loading: false,
  error: null,
};

// Create the slice
const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true; // Set loading to true when the API call is in progress
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when API call is successful
        state.users = action.payload; // Store fetched users in state
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.error = action.payload; // Store error in state
      })
      .addCase(getUserDetail.pending, (state) => {
        state.loading = true; // Set loading to true when the API call is in progress
      })
      .addCase(getUserDetail.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when API call is successful
        state.singleRecord = action.payload; // Store fetched user in state
      })
      .addCase(getUserDetail.rejected, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.error = action.payload; // Store error in state
      });
  },
});

export default usersSlice.reducer;
